import "./PreCall.scss";
import React from "react";
import App, { InterfaceAppState, InterfaceEasyCallMeState } from "../../App";
import { Button, ButtonGroup, Grid, IconButton, Tooltip } from "@mui/material";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MicIcon from "@mui/icons-material/Mic";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { withTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SettingsIcon from '@mui/icons-material/Settings';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import CloseIcon from '@mui/icons-material/Close';
import { UserAgentState } from "sip.js";
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import { HelperUtil } from "../../utils/helper";
import { flattenDiagnosticMessageText } from "typescript";
import { TIMEOUT } from "dns";
import { toast } from "react-toastify";
import i18next from "i18next";
import { SessionState } from "sip.js/lib/api/session-state";

class PreCall extends React.Component<any, {
    smallMode: boolean;
    showForm: boolean;
}> {
    constructor(props: any) {
        super(props);

        this.state = {
            smallMode: false,
            showForm: false,
        };

    }

    observer: ResizeObserver | null = null;

    render() {
        const AppComp: App = this.props.AppComp;
        const AppState: InterfaceAppState = this.props.AppState;
        const localCams = AppState.localCameras;
        const selectedCam = AppState.selectedCamera;
        const localMics = AppState.localMicrophones;
        const selectedMic = AppState.selectedMicrophone;
        const localSpks = AppState.localSpeakers;
        const selectedSpk = AppState.selectedSpeaker;
        const { t } = this.props;

        return (
            <>
                <div id="page-pre-call" className={(this.state.smallMode ? 'with-background ' : '') +
                    ((AppComp.state.withStyle &&
                        !(this.state.smallMode && (selectedCam && !AppState.audioOnly))) ? 'with-style ' : '')}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        zIndex: 1
                    }}>
                        <Button
                            disabled={!AppState.configurations?.back_url}
                            onClick={() => {
                                if (AppState.configurations) {
                                    window.location.href = AppState.configurations?.back_url
                                }
                            }}
                            id="btn-back"
                            className={AppComp.state.withStyle ? 'with-style ' : '' + (!AppState.configurations?.back_url ? 'hide' : '')}
                            color="primary"
                            startIcon={<ArrowBackIcon style={{ fontSize: this.state.smallMode ? "10vh" : "6vh" }} />}>
                        </Button>
                        <Button
                            onClick={() => {
                                this.setState({ showForm: !this.state.showForm })
                            }}
                            id="btn-gear"
                            className={AppComp.state.withStyle ? 'with-style ' : ''}
                            color="primary"
                            startIcon={<SettingsIcon style={{ fontSize: this.state.smallMode ? "10vh" : "6vh" }} />}>
                        </Button>
                    </div>
                    {/*      {
                        (window as any)._easy_link_config.mode != "embedded" &&
                        <div className={'header-logo'}>
                            <img className={'logo'} src={'https://' + (window as any)._easy_link_config.domain + '/branding/logo-login.png'} />
                        </div>
                    } */}
                    {(selectedCam && !AppState.audioOnly) &&
                        <video ref="pre-call-video" id="pre-call-video" controls={false} autoPlay={true}
                            muted={true} />
                    }

                    <Grid id={"pre-call-form-container"} >
                        <div id={"pre-call-form"}
                            className={(this.state.smallMode ? 'with-background ' : '') +
                                (AppComp.state.withStyle ? 'with-style ' : '') +
                                (this.state.showForm ? '' : 'hide')}>

                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                <div style={{ alignSelf: "center", display: "flex" }}>
                                    <p>{t('description_message')}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <Button
                                        id="btn-cross"
                                        className={AppComp.state.withStyle ? 'with-style ' : ''}
                                        onClick={() => {
                                            this.setState({ showForm: !this.state.showForm })
                                        }}
                                        startIcon={<CloseIcon style={{ marginLeft: 9 }} />}
                                    />
                                </div>
                            </div>
                            <div className={"div-main-control " +
                                (AppComp.state.withStyle ? 'with-style ' : '')}>
                                <ButtonGroup variant="contained" aria-label="outlined primary button group"
                                    className="button-group btn-main-control">
                                    <Button onClick={() => {
                                        if (AppState.audioOnly) {
                                            AppComp.setAudioOnly(false, (value) => {
                                                AppComp.initPreviewVideo();
                                            });
                                        } else {
                                            if (HelperUtil.showLogs()) {
                                                console.log('Audio only mode will be used, selected microphone', selectedMic);
                                            }
                                            AppComp.setAudioOnly(true, (value) => {

                                            });
                                        }
                                    }} className={AppState.audioOnly ? 'btn-main audio-only' : 'btn-main'}
                                        startIcon={!AppState.audioOnly ? <VideocamIcon /> : <VideocamOffIcon />}
                                        variant="outlined">
                                        <div className="ellip">{selectedCam ? selectedCam.label : ''}</div>
                                    </Button>
                                    <CustomSelect data={localCams.map(cam => {
                                        return {
                                            value: cam.deviceId,
                                            text: cam.label,
                                            selected: selectedCam && selectedCam.deviceId === cam.deviceId,
                                            data: cam
                                        }
                                    })} getToggleButton={(onClick) => {
                                        // @ts-ignore
                                        return <Button onClick={onClick}
                                            style={{ width: '40px' }}
                                            className={'btn-select-arrow'}><KeyboardArrowDownIcon /></Button>
                                    }} onSelect={item => {
                                        AppComp.selectCamera(item.data, (selectedCamera) => {
                                            if (selectedCamera) {
                                                const constraints: MediaStreamConstraints = {
                                                    audio: false,
                                                    video: { deviceId: selectedCamera.deviceId }
                                                };

                                                AppComp.initPreviewVideo(constraints);
                                            }
                                        });
                                    }} />
                                </ButtonGroup>
                            </div>
                            <div className={"div-main-control " +
                                (AppComp.state.withStyle ? 'with-style ' : '')}>
                                <ButtonGroup variant="contained" aria-label="outlined primary button group"
                                    className="button-group btn-main-control">
                                    <Button startIcon={<MicIcon />} variant="outlined" className="btn-main">
                                        <div className="ellip">{selectedMic ? selectedMic.label : ''}</div>
                                    </Button>
                                    <CustomSelect data={localMics.map(mic => {
                                        return {
                                            value: mic.deviceId,
                                            text: mic.label,
                                            selected: selectedMic && selectedMic.deviceId === mic.deviceId,
                                            data: mic
                                        }
                                    })} getToggleButton={(onClick) => {
                                        // @ts-ignore
                                        return <Button onClick={onClick}
                                            style={{ width: '40px' }}
                                            className={'btn-select-arrow'}><KeyboardArrowDownIcon /></Button>
                                    }} onSelect={item => {
                                        AppComp.selectMicrophone(item.data, selectedMicrophone => {

                                        });
                                    }} />
                                </ButtonGroup>
                            </div>
                            <div className={"div-main-control " +
                                (AppComp.state.withStyle ? 'with-style ' : '')}>
                                <ButtonGroup variant="contained" aria-label="outlined primary button group"
                                    className="button-group btn-main-control">
                                    {
                                        (AppState.speakerAvailable || (localSpks && localSpks.length)) ?
                                            <>

                                                <Button startIcon={<VolumeUpIcon />} variant="outlined"
                                                    className="btn-main">
                                                    <div
                                                        className="ellip">{selectedSpk ? selectedSpk.label : ''}</div>
                                                </Button>
                                                <CustomSelect data={localSpks.map(spk => {
                                                    return {
                                                        value: spk.deviceId,
                                                        text: spk.label,
                                                        selected: selectedSpk && selectedSpk.deviceId === spk.deviceId,
                                                        data: spk
                                                    }
                                                })} getToggleButton={(onClick) => {
                                                    // @ts-ignore
                                                    return <Button onClick={onClick}
                                                        style={{ width: '40px' }}
                                                        className={'btn-select-arrow'}><KeyboardArrowDownIcon /></Button>
                                                }} onSelect={item => {
                                                    AppComp.selectSpeaker(item.data, selectedSpeaker => {
                                                        AppComp.setupSpeakerVideo(selectedSpeaker, AppComp.audioOutgoing, () => {
                                                        }, () => {
                                                        });
                                                    });
                                                }} />
                                                {selectedSpk && <IconButton onClick={() => {
                                                    AppComp.testSpeaker(selectedSpk);
                                                }} className={"icon-btn " +
                                                    (AppComp.state.withStyle ? 'with-style ' : '')} aria-label="test speaker" color="success" style={
                                                        AppState.withStyle ? undefined : undefined
                                                        // {
                                                        //     position: 'absolute',
                                                        //     right: '-48px',
                                                        //     top: '-4px'
                                                        // }
                                                    }
                                                    size={AppState.withStyle ? "small" : 'small'}>
                                                    <PlayCircleFilledIcon
                                                        style={AppState.withStyle ? undefined : {
                                                            backgroundColor: 'white',
                                                            borderRadius: '100%'
                                                        }}
                                                        fontSize="large" />
                                                </IconButton>}
                                            </>
                                            :
                                            <>
                                                <Button startIcon={<VolumeUpIcon />} variant="outlined"
                                                    className="btn-main">
                                                    <div className="ellip">{t('speaker_placeholder_default')}</div>
                                                </Button>
                                            </>
                                    }
                                </ButtonGroup>
                            </div>
                        </div>
                    </Grid>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-evenly",
                        zIndex: 1
                    }}>
                        <Button onClick={() => {
                            this.startAudioCall();
                        }}
                            disabled={!selectedMic || !AppState.userAgent || AppState.userAgentState !== UserAgentState.Started}
                            id="btn-call" className={(AppState.withStyle ? 'with-style ' : '') +
                                (!(selectedMic) ? 'off' : '')
                            }
                            startIcon={selectedMic ?
                                <LocalPhoneIcon style={{ fontSize: "10vh", color: "white", marginLeft: 9 }} /> :
                                <div
                                    style={{ transform: `rotate(90deg)` }}
                                >
                                    <PhoneDisabledIcon style={{ fontSize: "10vh", color: "white", marginLeft: 9 }} />
                                </div>
                            }
                        />
                        <Tooltip title={AppState.audioOnly ? t('enable_camera_to_use') : ""} placement="top">
                            <Button onClick={() => {
                                this.startVideoCall()
                            }}
                                disabled={!selectedMic || !selectedCam || !AppState.userAgent || AppState.userAgentState !== UserAgentState.Started}
                                id="btn-video-call" className={(AppState.withStyle ? 'with-style ' : '') +
                                    (!(!AppState.audioOnly && selectedCam && selectedMic) ? 'off' : '')
                                }
                                startIcon={!AppState.audioOnly && selectedCam && selectedMic ?
                                    <VideocamIcon style={{ fontSize: "10vh", color: "white", marginLeft: 9 }} />
                                    : <VideocamOffIcon style={{ fontSize: "10vh", color: "white", marginLeft: 9 }} />
                                }
                            />
                        </Tooltip>

                    </div>
                    <div className={'footer-text'}>
                        {t('easy-call-me.access_page_footer_text', { "current-year": (new Date()).getFullYear().toString() })}
                    </div>
                </div>
            </>
        );
    }

    startAudioCall = () => {
        const AppComp: App = this.props.AppComp;
        const AppState: InterfaceAppState = this.props.AppState;
        AppComp.setAudioOnly(true, (value) => { });
        const selectedMic = AppState.selectedMicrophone;

        if (selectedMic) {
            const constraints: MediaStreamConstraints = {
                audio: { deviceId: selectedMic.deviceId },
                video: false,
            };

            AppComp.call(AppState.configurations?.call_destination, constraints);
        } else {
            console.error('No audio device found, call will not be made');
        }
    }

    startVideoCall = () => {
        const AppComp: App = this.props.AppComp;
        const AppState: InterfaceAppState = this.props.AppState;
        if (!AppState.audioOnly) {
            const selectedMic = AppState.selectedMicrophone;
            const selectedCam = AppState.selectedCamera;

            if (selectedMic) {
                const constraints: MediaStreamConstraints = {
                    audio: { deviceId: selectedMic.deviceId },
                    video: (selectedCam && !AppState.audioOnly) ? { deviceId: selectedCam.deviceId } : false,
                };
                AppComp.call(AppState.configurations?.call_destination, constraints);
            } else {
                console.error('No audio device found, call will not be made');
            }
        }
    }

    updateDimensions = () => {
        this.setState({ smallMode: window.innerWidth < 900 });
    };

    componentDidMount() {
        const AppComp: App = this.props.AppComp;
        const AppState: InterfaceAppState = this.props.AppState;

        AppComp.initPreviewVideo();

        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);

        if (AppState.keepAutoStart && AppState.autoStart && AppState.userAgent) {
            if (AppState.autoStart === "video") {
                if (AppState.selectedCamera && AppState.selectedMicrophone) {
                    if (!AppState.keepAutoStart)
                        AppComp.setState({ autoStart: null })
                    this.startVideoCall();
                } else if (AppState.selectedMicrophone)
                    toast.warning(i18next.t('no_camera_autostart_video'), {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                    });
            }
            else if (AppState.autoStart === "audio") {
                if (AppState.selectedMicrophone) {
                    if (!AppState.keepAutoStart)
                        AppComp.setState({ autoStart: null })
                    this.startAudioCall();
                }
            }
        }
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<{ smallMode: boolean; showForm: boolean; }>, snapshot?: any): void {
        const AppState: InterfaceAppState = this.props.AppState;
        const AppComp: App = this.props.AppComp;

        //you can't detect output devices on mozilla/safari
        //if (AppState.selectedSpeaker) { 
            
        if (AppState.autoStart && AppState.userAgent) {
            if (AppState.selectedCamera?.deviceId !== prevProps.AppState.selectedCamera?.deviceId
                || AppState.selectedMicrophone?.deviceId !== prevProps.AppState.selectedMicrophone?.deviceId
                || AppState.userAgentState !== prevProps.AppState.userAgentState
            ) {
                if (AppState.autoStart === "video") {
                    if (AppState.selectedCamera && AppState.selectedMicrophone) {
                        if (!AppState.keepAutoStart)
                            AppComp.setState({ autoStart: null })
                        this.startVideoCall();
                    } else if (AppState.selectedMicrophone)
                        toast.warning(i18next.t('no_camera_autostart_video'), {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                            progress: undefined,
                        });
                }
                else if (AppState.autoStart === "audio") {
                    if (AppState.selectedMicrophone) {
                        if (!AppState.keepAutoStart)
                            AppComp.setState({ autoStart: null })
                        this.startAudioCall();
                    }
                }
            }
        }
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        // this.observer?.disconnect();
        // this.observer = null;
    }
}

export default withTranslation()(PreCall);
